import { Badge } from '@/shared/ui/badge';
import { Button } from '@/shared/ui/button';
import { Field } from '@/shared/ui/field';
import { Input } from '@/shared/ui/input';
import { Panel, PanelGroup, PanelSection } from '@/shared/ui/panel';

export function PanelsSection() {
  return (
    <PanelGroup gap={12}>
      <Panel
        icon="layers"
        title="Series"
        subtitle="Group settings + per-group calculation"
        badge={<Badge tone="primary">PR-S25</Badge>}
        actions={
          <>
            <Button size="sm" iconLeft="detach">
              Detach
            </Button>
            <Button size="sm" variant="primary" iconLeft="save">
              Save
            </Button>
          </>
        }
      >
        <PanelGroup columns={2} gap={12}>
          <Panel variant="outline" icon="users" title="Capacity" density="tight">
            <PanelSection title="Per group">
              <Field label="Max group size" layout="inline">
                <Input defaultValue="32" />
              </Field>
              <Field label="Min group size" layout="inline">
                <Input defaultValue="8" />
              </Field>
            </PanelSection>
            <PanelSection title="Currency">
              <Field label="Default" layout="inline">
                <Input defaultValue="EUR" />
              </Field>
            </PanelSection>
          </Panel>
          <Panel
            variant="outline"
            icon="calendar"
            title="Dates"
            density="tight"
            badge={<Badge tone="draft">unsaved</Badge>}
          >
            <Field label="Departure">
              <Input defaultValue="15.6.2026" />
            </Field>
            <Field label="Return">
              <Input defaultValue="21.6.2026" />
            </Field>
          </Panel>
        </PanelGroup>
      </Panel>

      <Panel variant="outline" title="Outline standalone" icon="folder">
        <p className="text-phx-sm text-phx-text-muted">
          An outline panel sitting directly on the warm page background. Often used as a quieter
          wrapper when shadow would feel heavy.
        </p>
      </Panel>

      <Panel
        variant="ghost"
        title="Filters"
        icon="filter"
        actions={<Button size="sm" variant="ghost" iconLeft="x" />}
      >
        <div className="gap-phx-3 flex flex-wrap">
          <Button size="sm" active>
            All
          </Button>
          <Button size="sm">Active</Button>
          <Button size="sm">Archived</Button>
          <Button size="sm">Drafts</Button>
        </div>
      </Panel>

      <Panel
        title="Collapsible"
        subtitle="Click chevron or header to fold the body away"
        icon="layers"
        collapsible
        defaultOpen={false}
      >
        <p className="text-phx-sm text-phx-text-muted">Body content lives here.</p>
      </Panel>
    </PanelGroup>
  );
}
